import React from 'react'
import { useStyles } from './PrivateOfferActivityLog.styles'
import clsx from 'clsx'
import { Typography, useTheme } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMessages } from '@fortawesome/pro-regular-svg-icons'
import LabraIcon from '../../common/images/labraIcon.svg'

export type PrivateOfferActivityLogProps = {
  conditionalClassNamesForHubspot?: {
    hideActivityLog?: string
  }
}

export const PrivateOfferActivityLog: React.FC<
  PrivateOfferActivityLogProps
> = ({ conditionalClassNamesForHubspot }) => {
  const { classes } = useStyles()
  const theme = useTheme()
  return (
    <div
      className={clsx(
        classes.productNameWrapper,
        classes.activityLogWidth,
        conditionalClassNamesForHubspot?.hideActivityLog
      )}
    >
      <div className={classes.rootContainer}>
        <div className={classes.headingContainer}>
          <div className={classes.titleContainer}>
            <div
              className={classes.titleIconContainer}
              data-testid="heading-icon"
            >
              <div className={classes.titleIcon}>
                <FontAwesomeIcon
                  icon={faMessages}
                  style={{
                    width: theme.spacing(2.25),
                    height: theme.spacing(1.75),
                  }}
                />
              </div>
            </div>
            <Typography className={classes.heading} data-testid="box-heading">
              Activity log
            </Typography>
          </div>
        </div>
        <div className={classes.svgBackground}>
          <img src={LabraIcon} alt="Labra Icon" className={classes.labraIcon} />
        </div>
      </div>
    </div>
  )
}
